import React from 'react';
import PerformanceReviews from './PerformanceReviews';

const Performance = () => (
  <PerformanceReviews />
);

export default Performance;
